<template>
  <div>
    <v-dialog ref="dialog" v-model="menu" width="290px">
      <template #activator="{ on }">
        <div v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-time-picker v-model="date" scrollable v-bind="$props" @input="onInput">
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      //
    },
    min: {
      //
    },
    max: {
      //
    },
    allowedDates: {
      //
    }
  },
  data() {
    return {
      date: this.value,
      menu: false
    }
  },

  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>
